import withDemoData from '../withDemoData'
import useApi, { ApiRouteNames } from './useApi'

const useApiWithDemoData = withDemoData(useApi)
export { useApi, useApiWithDemoData, ApiRouteNames }
